module.exports = __webpack_public_path__ + "img/theme-d.c5d963b1.png";